<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-confirm-container">
          <CloseButton
            v-if="showCloseButton"
            @on-click="() => emit('onClose')"
            :absolute="true"
          />
          <div class="modal-confirm-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-confirm-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-confirm-footer mb-0">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">

import CloseButton from "@/apps/merchant3/shared-components/consumer/CloseButton.vue";

defineProps<{
  buttonText?: string;
  show?: boolean;
  showCloseButton?: boolean;
}>();

const emit = defineEmits<{ (e: "onClose"): void }>();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  margin-top: 2%;
}

.modal-confirm-container {
  position: relative;
  margin: 0 auto;
  padding: 16px;
  width: 90%;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.modal-confirm-header {
  color: black;
}

.modal-confirm-body {
  font-style: normal;
  left: 0;
  right: 0;
  color: #000;
  max-width: 80vw !important;
}

.modal-confirm-header > span:hover {
  cursor: pointer;
}

.modal-confirm-footer {
  display: flex;
  justify-content: space-around;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-confirm-container,
.modal-leave-to .modal-confirm-container {
  transform: translateY(-20px);
  opacity: 0;
}

.modal-button {
  border-radius: 8px;
}

.btn-success {
  margin-top: 15px;
  color: white;
  background-color: $pj-color-green;
  border-color: $pj-color-green;
  width: 161px;
  height: 48px;
}

.btn-success:hover {
  background-color: $pj-color-gray;
  border-color: $pj-color-gray;
}

.btn-outline-success {
  margin-top: 17px;
  color: $pj-color-green;
  border-color: $pj-color-green;
  width: 131px;
  height: 44px;
}

.btn-outline-success:hover {
  color: white;
  background-color: $pj-color-gray;
  border-color: $pj-color-gray;
}

.btn-success:focus,
.btn-outline-success:focus {
  box-shadow: none;
}
</style>
